















import { Product } from '@/model/product';
import { GTMBroker } from '@/service/gtm-broker';
import { ProductCollection } from '@/service/product';
import { ShoppingCartCollection } from '@/service/shopping-cart';
import Vue from 'vue';

export default Vue.extend({
  name: 'OrderButton',
  props: {
    amount: {
      type: Number,
      default: 0
    },
    productKey: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: 'button.addToCart'
    },
    showLinkText: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    isDisabled() {
      if (this.product) {
        if (this.stock < this.product.multipleSalesQuantity) return true;
      }
      return false;
    }
  },
  watch: {
    productKey() {
      this.refresh();
    },
    amount() {}
  },
  data() {
    return <{ product: Product | null; stock: number }>{
      product: null,
      stock: -1
    };
  },
  mounted() {
    this.refresh();
  },
  methods: {
    refresh() {
      ProductCollection.getInstance()
        .getProduct(this.productKey)
        .then(product => {
          this.product = product;
          return product.getStock();
        })
        .then(stock => (this.stock = stock));
    },
    addToCart() {
      if (this.product == null) {
        return;
      }
      const product: Product = this.product;

      ShoppingCartCollection.getInstance()
        .putProductInShoppingCart(product, this.amount)
        .then(result => {
          this.$emit('added-to-cart', product.getKey(), this.amount, product);
          GTMBroker.getInstance().productAddedToCart(product, this.amount);
        });
    }
  }
});
